import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '@/lib/utils';

const Tabs = TabsPrimitive.Root;

const fixedHeight = 'h-11 md:h-10 lg:h-[3.25rem]'; // We need a fixed height for TabsList and TabsTrigger to render a status bar with custom borders

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      fixedHeight,
      'flex space-x-6 md:space-x-12 items-start justify-start border-b border-light-grey-500',
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      fixedHeight,
      // Base styles
      'flex flex-col cursor-pointer items-center justify-start h-11 md:h-10 lg:h-[3.25rem] whitespace-nowrap font-nunito700 text-sm md:text-base lg:text-lg border-b transition-all',
      // Focus state
      'focus-visible:outline-hidden',
      'focus-visible:ring-0',
      'focus-visible:ring-offset-0',
      // Active state
      'data-[state=active]:border-b-2',
      'data-[state=active]:border-black',
      'data-[state=active]:text-black',
      // Inactive state
      'data-[state=inactive]:border-light-grey-500',
      'data-[state=inactive]:text-light-grey-500',
      // Hover states
      'data-[state=inactive]:hover:text-black',
      'data-[state=inactive]:hover:border-black',
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'focus-visible:outline-hidden focus-visible:ring-0',
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
